import { AppSettings } from '../app.settings';
import { CriticalScreenFiltersDataModel } from './critcal-screen-filters-data-model';

export class CriticalScreenFilterModel {
  screenCode: String = AppSettings.FILTER_SCREEN_CODE.VEHICLES_SCREEN;
  filterData: CriticalScreenFiltersDataModel = new CriticalScreenFiltersDataModel();

  constructor(options?: {
    screenCode?: String,
    filterData: CriticalScreenFiltersDataModel
  }) {
    if (options) {
      this.screenCode = options.screenCode;
      this.filterData = options.filterData;
    }
  }
};
